/**
 * This is the forgotten service.
 * @memberOf Forgotten Module
 * @namespace Forgotten Service
 */

/**
 * @name ForgottenService
 * @desc Create the service.
 * @param $q
 * @param forgottenDataService
 * @memberOf Forgotten Module.Forgotten Service
 * @ngInject
 */
function forgottenFactory($q, forgottenDataService) {
    // Create the service.
    var service = {};
    return service;
}

export default forgottenFactory;



// WEBPACK FOOTER //
// ./src/login/forgotten/forgotten.service.js